import { Backpack } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconBackpack(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Backpack />
    </IconWrapper>
  );
}
